import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import { AUTH_BASE_URL } from "./auth.service";

const API = axios.create({
  baseURL: AUTH_BASE_URL,
});

API.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers = AxiosHeaders.from(config.headers);
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  return config;
});

// Mutex : une seule tentative de refresh simultanée
let refreshPromise: Promise<void> | null = null;

function clearSession() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("tokenExpiresAt");
}

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem("refreshToken");

      if (!refreshToken) {
        clearSession();
        window.location.href = "/redaction/login";
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      if (!refreshPromise) {
        refreshPromise = axios
          .post(`${AUTH_BASE_URL}/auth/refresh`, { refreshToken })
          .then((res) => {
            const data = res.data.donnees;
            if (data?.accessToken) localStorage.setItem("accessToken", data.accessToken);
            if (data?.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
            if (data?.expiresIn) localStorage.setItem("tokenExpiresAt", String(Date.now() + data.expiresIn * 1000));
          })
          .finally(() => {
            refreshPromise = null;
          });
      }

      try {
        await refreshPromise;
        originalRequest.headers = AxiosHeaders.from(originalRequest.headers);
        originalRequest.headers.set("Authorization", `Bearer ${localStorage.getItem("accessToken")}`);
        return API(originalRequest);
      } catch {
        clearSession();
        window.location.href = "/redaction/login";
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default API;
